<template>
  <div>
    <Modal :isOpen="isOpen">
      <template v-slot:header v-if="threads.markersLayered[pinId]">
        <div class="pinHeaderWrapper">
          <div class="pinCircle">{{ pinId }}</div>
          {{ threads.markersLayered[pinId].title }}
        </div>
      </template>
      <template v-slot:header v-else>Načítání...</template>
      <template v-slot:content v-if="threads.markersLayered[pinId]">
        <div
          ref="publishWrapper"
          class="publishWrapper"
          v-if="
            threads.markersLayered[pinId].permissions.canPublish &&
            !threads.markersLayered[pinId].status
          "
        >
          <span class="publishInfo">Čeká na schválení k zveřejnění</span>
          <button
            class="btnStyled edit publishButton"
            @click="
              publishPin(
                pinId,
                threads.markersLayered[pinId].drawingId,
                1,
                $event
              )
            "
          >
            <i class="fas fa-check"></i> Zveřejnit
          </button>
        </div>
        <br />
        <!--<CommentNewForm />-->
        <div v-html="threads.markersLayered[pinId].text_detail"></div>
        <div v-if="threads.markersLayered[pinId].moreData">
          <table>
            <tr v-if="threads.markersLayered[pinId].moreData.kod_fp">
              <th>Kód FP</th>
              <td>{{ threads.markersLayered[pinId].moreData.kod_fp }}</td>
            </tr>
            <tr v-if="threads.markersLayered[pinId].moreData.parc_cisl">
              <th>Číslo parcey</th>
              <td>{{ threads.markersLayered[pinId].moreData.parc_cisl }}</td>
            </tr>
            <tr v-if="threads.markersLayered[pinId].moreData.s_1NP">
              <th>m2 HPP v&nbsp;1.PP</th>
              <td>{{ threads.markersLayered[pinId].moreData.s_1NP }}</td>
            </tr>
            <tr v-if="threads.markersLayered[pinId].moreData.s_1NP_zastav">
              <th>m2 HPP v&nbsp;1.NP – zastavěná plocha</th>
              <td>{{ threads.markersLayered[pinId].moreData.s_1NP_zastav }}</td>
            </tr>
            <tr v-if="threads.markersLayered[pinId].moreData.s_2NP">
              <th>m2 HPP v&nbsp;2.NP nebo podkroví</th>
              <td>{{ threads.markersLayered[pinId].moreData.s_2NP }}</td>
            </tr>
            <tr v-if="threads.markersLayered[pinId].moreData.s_3NP">
              <th>m2 HPP v&nbsp;3.NP nebo podkroví</th>
              <td>{{ threads.markersLayered[pinId].moreData.s_3NP }}</td>
            </tr>
            <tr v-if="threads.markersLayered[pinId].moreData.s_4NP">
              <th>m2 HPP v&nbsp;4.NP nebo podkroví</th>
              <td>{{ threads.markersLayered[pinId].moreData.s_4NP }}</td>
            </tr>
            <tr v-if="threads.markersLayered[pinId].moreData.s_5NP">
              <th>m2 HPP v&nbsp;5.NP nebo podkroví</th>
              <td>{{ threads.markersLayered[pinId].moreData.s_5NP }}</td>
            </tr>
            <tr v-if="threads.markersLayered[pinId].moreData.hpp">
              <th>Hrubá podlažní plocha (HPP) celkem</th>
              <td>{{ threads.markersLayered[pinId].moreData.hpp }}</td>
            </tr>
            <tr v-if="threads.markersLayered[pinId].moreData.podlaznost">
              <th>Prům. podlažnost</th>
              <td>{{ threads.markersLayered[pinId].moreData.podlaznost }}</td>
            </tr>
            <tr v-if="threads.markersLayered[pinId].moreData.koef_HPP">
              <th>Koeficient snížení plochy HPP v&nbsp;podkroví</th>
              <td>{{ threads.markersLayered[pinId].moreData.koef_HPP }}</td>
            </tr>
            <tr v-if="threads.markersLayered[pinId].moreData.popis">
              <th>Popis</th>
              <td>{{ threads.markersLayered[pinId].moreData.popis }}</td>
            </tr>
            <tr v-if="threads.markersLayered[pinId].moreData.popis2">
              <th></th>
              <td>{{ threads.markersLayered[pinId].moreData.popis2 }}</td>
            </tr>

            <!-- ZmenyUP -->
            <tr
              v-if="threads.markersLayered[pinId].moreData.zmenyUP_plochaZmeny"
            >
              <th>Plocha změny</th>
              <td>
                {{ threads.markersLayered[pinId].moreData.zmenyUP_plochaZmeny }}
                m<sup>2</sup>
              </td>
            </tr>
            <tr v-if="threads.markersLayered[pinId].moreData.odkaz">
              <th>Odkaz</th>
              <td>
                {{ threads.markersLayered[pinId].moreData.odkaz }} m<sup>2</sup>
              </td>
            </tr>
          </table>
        </div>
        <br />
        <div v-if="threads.markersLayered[pinId].attachments">
          <a
            v-for="file in threads.markersLayered[pinId].attachments"
            :key="file.id"
            :href="attachmentUrl(file)"
            target="_blank"
            style="margin-right: 5px;"
            >Příloha</a
          >
        </div>
        <br />
        <div class="supportWrapper" v-if="isVotingAllowed">
          <div>
            Podpořilo
            <strong>{{
              threads.markersLayered[pinId].supportersCounter
            }}</strong>
          </div>
          <WizardEventDispatcher
            :event="'click'"
            :target="'button-support-pin'"
          >
            <button
              class="btnStyled support"
              style="font-size: 11px;"
              @click="
                supportPin(pinId, threads.markersLayered[pinId].drawingId)
              "
            >
              <i class="far fa-thumbs-up"></i> Podpořit
            </button>
          </WizardEventDispatcher>
        </div>
        <div class="printButtonWrapper">
          <SingleLayerPinPrintButton :pin-id="pinId" />
        </div>
        <div
          v-if="
            threads.markersLayered[pinId].comments ||
            threads.markersLayered[pinId].permissions.canComment
          "
          class="comments-wrapper"
        >
          <div v-if="threads.markersLayered[pinId].comments">
            <div
              v-for="comment in threads.markersLayered[pinId].comments"
              :key="comment.id"
              class="comments-tab"
            >
              <div class="senderInfo">
                <div class="name">
                  {{ comment.author.firstName }}
                  {{ comment.author.lastName }}
                </div>
                <div>{{ getFullDate(comment.date.date) }}</div>
              </div>
              <div class="text">{{ comment.text }}</div>
            </div>
          </div>
          <form
            @submit="sendCommentForm"
            method="post"
            class="form-horizontal"
            v-if="threads.markersLayered[pinId].permissions.canComment"
          >
            <div class="form-control">
              <label for="frm-drawingPinForm-text">Nový komentář</label>
              <textarea
                name="text"
                class="form-control"
                v-model="newCommentText"
                required
              ></textarea>
            </div>

            <br />
            <WizardEventDispatcher
              :event="'click'"
              :target="'button-save-comment'"
            >
              <input
                type="submit"
                class="btn btn-primary"
                value="Přidat komentář"
              />
            </WizardEventDispatcher>
          </form>
        </div>
      </template>
    </Modal>
  </div>
</template>

<script>
import Modal from '@/components/Modal.vue';
import { mapState } from 'vuex';
import PinService from '@/services/PinService';
import { getFullDate } from '@/utils/date';
import { PINS_ATTACHMENTS_URL } from '@/constants/global.js';
import WizardEventDispatcher from '@/components/wizard/WizardEventDispatcher.vue';
import SingleLayerPinPrintButton from '@/components/sidebar/SingleLayerPinPrintButton.vue';

export default {
  props: {
    pinId: {
      type: Number,
      required: true
    },
    isOpen: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      commentsDetailOpen: false,
      newCommentFormVisible: false,
      newCommentText: null
    };
  },
  computed: {
    ...mapState(['general', 'threads']),
    isVotingAllowed: function () {
      let pinTypeId = this.threads.markersLayered[this.pinId].pinTypeId;

      if (pinTypeId) {
        let pinType = this.threads.pinTypes[pinTypeId];

        return pinType.voting_allowed == 1 ? true : false;
      }

      return false;
    }
  },
  components: {
    Modal,
    WizardEventDispatcher,
    SingleLayerPinPrintButton
  },
  created() {
    this.newCommentFormVisible = this.threads.markersLayered[
      this.pinId
    ].permissions.canComment;
  },
  methods: {
    attachmentUrl: (attachment) => {
      return `${PINS_ATTACHMENTS_URL}${attachment.filePath}`;
    },
    getFullDate(dateTime) {
      return getFullDate(dateTime);
    },
    sendCommentForm(e) {
      e.preventDefault();
      const data = {
        text: this.newCommentText
      };

      PinService.addComment(
        this.pinId,
        this.threads.markersLayered[this.pinId].drawingId,
        data
      )
        .then((response) => {
          this.threads.markersLayered[this.pinId].comments.push(
            response.data.data
          );

          // this.newCommentFormVisible = false
          this.newCommentText = null;
          this.commentsDetailOpen = true;
        })
        .catch(() => {});
    },
    supportPin(pinId, layerId) {
      PinService.voteForPin(pinId, layerId)
        .then((response) => {
          this.threads.markersLayered[pinId].supportersCounter++;
          this.$toasted.show('Pin podpořen.', {
            type: 'success',
            position: 'top-right',
            duration: '5000'
          });
        })
        .catch(() => {});
    },

    publishPin(pinId, layerId, status, event) {
      PinService.updatePinStatus(pinId, layerId, status)
        .then((response) => {
          event.target.parentElement.remove();
          this.$toasted.show('Hotovo.', {
            type: 'success',
            position: 'top-right',
            duration: '5000'
          });
        })
        .catch(() => {});
    }
  },
  created() {}
};
</script>

<style scoped>
.pinHeaderWrapper {
  line-height: 2;
  display: flex;
  align-items: center;
  font-size: 15px;
}
.pinCircle {
  width: 34px;
  height: 34px;
  border-radius: 50%;
  color: white;
  text-align: center;
  background: #00897b;
  line-height: 2.4;
  margin-right: 10px;
  font-size: 14px;
  margin-left: 10px;
}
.publishWrapper {
  display: flex;
  flex-flow: row;
  background-color: pink;
  justify-content: space-between;
  text-align: center;
  padding: 10px;
  margin: -15px;
  font-size: 11px;
}

.publishWrapper .publishInfo {
  display: flex;
  align-self: center;
  font-size: 11px;
}

.publishButton {
  font-size: 11px;
}

.supportWrapper {
  display: flex;
  flex-flow: row;
  justify-content: space-between;
}

.printButtonWrapper {
  border-top: 0.5px solid lightgrey;
  margin-top: 20px;
  padding-top: 10px;
}

.comments-wrapper {
  margin-top: 10px;
  padding-top: 10px;
  border-top: 0.5px solid lightgrey;
}

.comments-tab {
  display: flex;
  flex-flow: column;
  background-color: #f4f6f7;
  padding: 10px;
  margin-bottom: 1px;
}

.comments-tab .senderInfo {
  display: flex;
  flex-flow: row;
  justify-content: space-between;
  color: gray;
}

.comments-tab .senderInfo .name {
  font-weight: 600;
  margin-bottom: 5px;
}

.comments-tab .text {
  margin-left: 5px;
  white-space: initial;
}
.addComment {
  margin-left: 6px;
}
</style>
